const { construct } = require('./../../tools/construct')

function getByAlias (state, productId, {resolveAlias, date}) {
  let [, aliasValue] = productId.split(':')
  aliasValue = aliasValue.toUpperCase()
  if (!aliasValue) {
    return Promise.reject(
      new Error(
        `Received malformed product id "${productId}", expected "product:<id>"`
      )
    )
  }
  const [aliasName] = Object.keys(resolveAlias)
  return state.dal.product.getByAlias(state, aliasValue, aliasName)
    .then((result) => {
      const docs = result && result.rows ? result.rows.map(row => row.doc).filter(Boolean) : []
      if (docs.length) {
        return construct(pickAliasedProduct(docs, aliasValue), { now: date })
      }
      throw new Error(`Product "${productId}" could not be found using alias "${aliasName}"`)
    })
}

// When an alias resolves to more than one product, a manufacturer-specific SKU
// and its generic parent can both carry the same `one` alias. Prefer the
// manufacturer-specific SKU (a child whose genericParent differs from its own
// code) so batches are created against e.g. product:ghsc-mal0009c instead of
// the generic product:ghsc-mal0009. Falls back to the first match otherwise.
function pickAliasedProduct (docs, aliasValue) {
  if (docs.length === 1) {
    return docs[0]
  }
  const isManufacturerSpecific = doc =>
    doc.genericParent &&
    doc.code &&
    doc.genericParent.toUpperCase() !== doc.code.toUpperCase()
  const specificDocs = docs.filter(isManufacturerSpecific)
  const candidates = specificDocs.length ? specificDocs : docs
  const exactCodeMatch = candidates.find(doc => doc.code && doc.code.toUpperCase() === aliasValue)
  return exactCodeMatch || candidates[0]
}

exports.get = function (state, productId, {resolveAlias = null, date = new Date().toISOString()} = {}) {
  if (!productId) {
    return Promise.reject(new Error('missing productId'))
  }

  if (resolveAlias) {
    return getByAlias(state, productId, {resolveAlias, date})
  }

  return state.dal.product.get(state, productId)
    .then(product => construct(product, { now: date }))
}
